import { UnitWorkloadDetails } from '#server/models';
import { Note } from './Note';

interface UnitWorkloadPanelProps {
  unitWorkloadDetails: UnitWorkloadDetails;
}

export const UnitDetailsPanel = ({ unitWorkloadDetails }: UnitWorkloadPanelProps) => {
  return (
    <div className="bottom-4 flex h-full basis-1/5 flex-col items-start justify-between bg-primary-website-background-colour py-[56px]">
      <div className="flex flex-shrink-0 flex-col items-start gap-5 px-5 text-base leading-6 text-primary-black-90">
        <h4 className="text-lg font-bold">Assigned unit coordinator</h4>
        <div className="text-primary-black-60 text-sm font-normal">
          Unit coordinators can be assigned in Student One. If the Unit Coordinator details are incorrect, please
          contact your School's Teaching Support Officer and the AWMS Support Team to have this data updated in Student
          One and AWMS.{' '}
        </div>
        <div className="flex-start flex items-center gap-2">
          {unitWorkloadDetails?.coordinatorCurtinId ? (
            <>
              <span className="font-bold">
                {`${unitWorkloadDetails?.coordinatorLastName ? `${unitWorkloadDetails?.coordinatorLastName}, ` : ''} ${unitWorkloadDetails?.coordinatorFirstName ? unitWorkloadDetails?.coordinatorFirstName : ''} `}
              </span>
              <span className="font-normal">{unitWorkloadDetails?.coordinatorCurtinId}</span>
              <span className="font-normal">{unitWorkloadDetails?.employmentStatusAbbr}</span>
            </>
          ) : (
            <span className="font-bold text-tertiary-red">Not Available</span>
          )}
        </div>
      </div>

      <Note unitWorkloadDetails={unitWorkloadDetails} />
    </div>
  );
};
